import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/kleider", label: "Kleider" },
  { to: "/#so-funktionierts", label: "So funktioniert's" },
  { to: "/#anfrage", label: "Anfrage" },
  { to: "/#anprobe", label: "Anprobe" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-black/85 backdrop-blur-md border-b border-gold/20" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-28 md:h-32">
        <Link to="/" data-testid="nav-logo" className="flex items-center select-none">
          <img
            src="https://customer-assets.emergentagent.com/job_dress-rental-8/artifacts/addnkbh0_01282ab7-d3ab-4bd8-a457-edb52e8d5072.jpeg"
            alt="10/10 Kleiderverleih"
            className="h-20 md:h-24 w-auto object-contain"
            style={{
              mixBlendMode: "screen",
              WebkitMaskImage:
                "radial-gradient(ellipse 75% 75% at 50% 50%, black 55%, transparent 100%)",
              maskImage:
                "radial-gradient(ellipse 75% 75% at 50% 50%, black 55%, transparent 100%)",
            }}
          />
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\W+/g, "-")}`}
              className="text-sm tracking-wider uppercase link-underline text-cream/90 hover:text-gold"
            >
              {l.label}
            </Link>
          ))}
        </div>

        <Link
          to="/kleider"
          data-testid="nav-cta"
          className="hidden md:inline-flex items-center px-6 py-3 bg-gold text-ink text-xs tracking-widest uppercase hover:bg-cream transition-colors duration-300"
        >
          Kollektion
        </Link>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 -mr-2 text-cream"
          aria-label="Menu"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-md border-t border-gold/20 px-6 py-6 space-y-4">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\W+/g, "-")}`}
              className="block text-sm uppercase tracking-wider text-cream/90"
            >
              {l.label}
            </Link>
          ))}
          <Link to="/kleider" className="inline-block px-6 py-3 bg-gold text-ink text-xs tracking-widest uppercase">
            Kollektion
          </Link>
        </div>
      )}
    </nav>
  );
}
